import { compareValues } from "@sscs/utils";
import { isSecretTriaged } from "../../../utils";
/** Initial state for secrets table filter */
export const initFilter = {
    secret_liveness: "ALL",
    service: "",
    endpoint: "",
    hide_triaged: true,
};
/** Initial state for secrets table sort */
export const initSort = {
    property: "exposure",
    reverse: true,
};
/** Initial state for secrets table pagination */
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export function filterSecret(secret, filter) {
    var _a;
    const status = filter.secret_liveness === "ALL"
        ? true
        : ((_a = secret.liveness) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === filter.secret_liveness;
    const service = filter.service
        ? secret.service.toLowerCase() === filter.service.toLowerCase()
        : true;
    const endpointLabel = filter.endpoint
        ? secret.endpoints.some((endpoint) => { var _a; return ((_a = endpoint.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === filter.endpoint.toLowerCase(); })
        : true;
    const hideTriaged = filter.hide_triaged
        ? !isSecretTriaged(secret.policy, secret.exposed)
        : true;
    return status && service && endpointLabel && hideTriaged;
}
export const specialCasesForSorting = {
    exposure: (first, second, reverse) => {
        if (first.exposed === second.exposed) {
            return compareValues(first.timestamp, second.timestamp, reverse);
        }
        else {
            return compareValues(first.exposed, second.exposed, reverse);
        }
    },
    status: (first, second, reverse) => 
    // sort bad first (Fail), then good (Pass) when reverse which is alphabetic sort flipped
    compareValues(first.policy.status, second.policy.status, !reverse),
};
//# sourceMappingURL=utils.js.map